import React from "react";
import { Menu, Layout } from "antd";
import { Link } from "react-router-dom";
import "./AppSidebar.scss";
import HomeIcon from "icons/HomeIcon";
import SendMoneyIcon from "icons/SendMoneyIcon";
import ManageOrderIcon from "icons/ManageOrderIcon";
import ManageBeneficiariesIcon from "icons/ManageBeneficiariesIcon";
import ManageProfileIcon from "icons/ManageProfileIcon"
// import SettingsIcon from "icons/SettingsIcon";
// import SignOutIcon from "icons/SignOutIcon";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import ManageOriginatorsIcon from "../../icons/ManageOriginatorsIcon";
import { FormattedMessage } from "react-intl";
import ReportIcon from "../../icons/ReportIcon";
import BatchUploadIcon from "../../icons/BatchUploadIcon";
import {connect} from "react-redux";
import withUseIntl from "../withUseIntl";
import {loginSuccess} from "../../rx/user/userAction";

const { Sider } = Layout;

class AppSidebar extends React.Component {
  state = {
    selectedKey: "",
    isCollapsed: false,
    browserWidth: 0
  };

  componentDidMount() {
    const pathName = this.props.history.location.pathname;
    let selectedKey = "transfer";
    if (pathName) {
      selectedKey = pathName.split("/")[2];
    }
    this.setState({ selectedKey });
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentDidUpdate() {
    const pathName = this.props.history.location.pathname;
    if (pathName) {
      const selectedKey = pathName.split("/")[2];
      if (selectedKey !== this.state.selectedKey) {
        this.setState({ selectedKey })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions() {
    this.setState({browserWidth: window.innerWidth});
  }

  onMenuSelected = menu => {
    this.setState({
      selectedKey: menu.key
    });
  };

  handleSignOut = () => {
    const { onSignOut } = this.props
    if (onSignOut) onSignOut()
  };

  handleCollapseMenu = () => {
    this.setState({isCollapsed: !this.state.isCollapsed})
  };

  render() {
    const { browserWidth } = this.state;

    var isNotReadOnly = this.props.currentUser && !this.props.currentUser.role.readOnly;
    var isReadOnly = this.props.currentUser && this.props.currentUser.role.readOnly;
    var isFullAccess = this.props.currentUser && this.props.currentUser.role.fullAccess;
    var isNotApproval = this.props.currentUser && !this.props.currentUser.approval;
    var isApprovalCreator = this.props.currentUser && this.props.currentUser.approval && this.props.currentUser.role.creator;
    var isBatchUpload = this.props.currentUser && this.props.currentUser.role.batchUpload;
    return (
      <>
      {browserWidth > 767 && (
        <Sider className={classNames("app-sidebar", {
                "is-collapsed": this.state.isCollapsed
              })} width={300}>
          <Menu
            className="app-sidebar-menu"
            onSelect={this.onMenuSelected}
            mode="inline"
            defaultSelectedKeys={["transfer"]}
            selectedKeys={[this.state.selectedKey]}
          >
            
            {this.props.currentCustomer.isPartner && (<Menu.Item key="dashboard">
              <Link to="/pages/dashboard" className="nav-text">
                <ManageOriginatorsIcon className="sidebar-icon"/>
                <span className="menu-title"><FormattedMessage id="app.sidebar.dashboard" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.dashboard" /></span>
              </Link>
            </Menu.Item>
            )}

            
            
            {(isReadOnly || isFullAccess || isNotApproval || isApprovalCreator) && (
            <Menu.Item key="transfer">
              <Link to="/" className="nav-text">
                <SendMoneyIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.sendmoney" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.send" /></span>
              </Link>
            </Menu.Item>)}

            {((this.props.currentCustomer.isPartner && isNotReadOnly) || isBatchUpload) && (
            <Menu.Item key="batch">
              <Link to="/pages/batch/upload" className="nav-text">
                <BatchUploadIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.batch.upload" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.batch.upload" /></span>
              </Link>
            </Menu.Item>)}

            <Menu.Item key="order">
              <Link to="/pages/order" className="nav-text">
                <ManageOrderIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.manageorders" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.orders" /></span>
              </Link>
            </Menu.Item>

            {this.props.currentCustomer.isPartner && 
            <Menu.Item key="originators">
              <Link to="/pages/originators" className="nav-text">
                <ManageOriginatorsIcon className="sidebar-icon"/>
                <span className="menu-title"><FormattedMessage id="app.sidebar.managesenders" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.senders" /></span>
              </Link>
            </Menu.Item>}

            <Menu.Item key="beneficiaries">
              <Link to="/pages/beneficiaries" className="nav-text">
                <ManageBeneficiariesIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.managebeneficiaries" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.beneficiaries" /></span>
              </Link>
            </Menu.Item>
            <Menu.Item key="profile">
              <Link to="/pages/profile" className="nav-text">
                <ManageProfileIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.manageprofile" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.profile" /></span>
              </Link>
            </Menu.Item>

            {this.props.currentCustomer.isPartner && (<Menu.Item key="transactions">
              <Link to="/pages/transactions" className="nav-text">
                <ReportIcon className="sidebar-icon"/>
                <span className="menu-title"><FormattedMessage id="app.sidebar.transactionhistory" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.transactionhistory" /></span>
              </Link>
            </Menu.Item>
            )}

            <Menu.Item key="report">
              <Link to="/pages/report" className="nav-text">
                <ReportIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.report" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.report" /></span>
              </Link>
            </Menu.Item>

          </Menu>

          <div className={"collapse-menu-btn"} onClick={this.handleCollapseMenu}>
            <span className="collapse-icon">
              {this.state.isCollapsed ? (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M15 0C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V1C0 0.447715 0.447715 0 1 0H15ZM8.55148 7.67194L5.60641 10.617L6.33328 11.3439L9.64178 8.03538C9.74204 7.93512 10 7.67194 10 7.67194C10 7.67194 9.74204 7.40877 9.64178 7.30851L6.33328 4L5.60641 4.72687L8.55148 7.67194Z" fill="white"/>
                </svg>

              ) : (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447715 16 1 16H15C15.5523 16 16 15.5523 16 15V1C16 0.447715 15.5523 0 15 0H1ZM6.71646 8.04117L9.66154 10.9862L8.93467 11.7131L5.62616 8.40461C5.5259 8.30435 5.26795 8.04117 5.26795 8.04117C5.26795 8.04117 5.5259 7.778 5.62616 7.67774L8.93467 4.36923L9.66154 5.0961L6.71646 8.04117Z" fill="white"/>
                </svg>

              )}
            </span>
            <span className={"text"}>
            <FormattedMessage id="app.sidebar.collapsemenu" />
            </span>
          </div>
        </Sider>
      )}
      {browserWidth <= 767 && (
        <div className="app-sidebar">
          <Menu
            className="app-sidebar-menu"
            onSelect={this.onMenuSelected}
            mode="inline"
            defaultSelectedKeys={["transfer"]}
            selectedKeys={[this.state.selectedKey]}
          >
            
            {this.props.currentCustomer.isPartner && (<Menu.Item key="dashboard">
              <Link to="/pages/dashboard" className="nav-text">
                <ManageOriginatorsIcon className="sidebar-icon"/>
                <span className="menu-title"><FormattedMessage id="app.sidebar.dashboard" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.dashboard" /></span>
              </Link>
            </Menu.Item>
            )}

            { (isReadOnly || isFullAccess || isNotApproval || isApprovalCreator) && (
            <Menu.Item key="transfer">
              <Link to="/" className="nav-text">
                <SendMoneyIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.sendmoney" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.send" /></span>
              </Link>
            </Menu.Item>)}

            <Menu.Item key="order">
              <Link to="/pages/order" className="nav-text">
                <ManageOrderIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.manageorders" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.orders" /></span>
              </Link>
            </Menu.Item>
            <Menu.Item key="beneficiaries">
              <Link to="/pages/beneficiaries" className="nav-text">
                <ManageBeneficiariesIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.managebeneficiaries" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.beneficiaries" /></span>
              </Link>
            </Menu.Item>
            {this.props.currentCustomer.isPartner && <Menu.Item key="originators">
              <Link to="/pages/originators" className="nav-text">
                <ManageOriginatorsIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.managesenders" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.senders" /></span>
              </Link>
            </Menu.Item>}
            <Menu.Item key="profile">
              <Link to="/pages/profile" className="nav-text">
                <ManageProfileIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.manageprofile" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.profile" /></span>
              </Link>
            </Menu.Item>
            {/*
            <Menu.Item key="report">
              <Link to="/pages/report" className="nav-text">
                <ReportIcon className="sidebar-icon" />
                <span className="menu-title"><FormattedMessage id="app.sidebar.report" /></span>
                <span className="menu-mobile-title"><FormattedMessage id="app.sidebar.report" /></span>
              </Link>
            </Menu.Item>
            */}
          </Menu>
        </div>
      )}
    </>
  );
}
}

const mapStateToProps = state =>{
  return {
    currentUser: state.user.currentUser
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps) (withUseIntl(AppSidebar)));
